import { ColumnOptionsBase, ServerSideColumnOption } from '../types/column-options';
import { DateColumn } from '../types/grid';
import { IsoDate } from '@softline/core';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface DateColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, IsoDate> {
  format?: string;
  rowGroup?: boolean;
}

export type ServerSideDateColumnOptions<TRow extends object> = DateColumnOptions<TRow> & ServerSideColumnOption;

export function dateColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow> | EntityColumnRef<TRow>,
                                                options: DateColumnOptions<TRow> | ServerSideDateColumnOptions<TRow>): DateColumn<TRow> {
  const column: DateColumn<TRow> = {
    ...options,
    type: 'date',
    format: options.format ?? 'DATE.DEFAULT',
  }
  ref.createColumn(column);
  return column;
}
